<template>
	<div class="home-v2-jobs-app-container">
		<spinner v-if="loading && items.length === 0" />

		<div v-else-if="items.length > 0" class="jobs-results">
			<job v-for="item in items" :key="item.uuid" :item="item" :logo_url_template="logo_url_template" />
		</div>
	</div>
</template>

<style lang="scss" scoped>
@use 'sass:math';

@use '/sass/variables' as *;
@use '/sass/toolkit' as *;

.jobs-results {
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: $spacer;
}

@include media('<=landscape') {
	.jobs-results {
		grid-template-columns: repeat(2, 1fr);
	}
}

@include media('<=phone') {
	.jobs-results {
		grid-template-columns: 1fr;
	}
}
</style>

<script setup>
import { useFetch } from '@vueuse/core';
import { computed } from 'vue';

import Job from './jobs-app/_job.vue';
import Spinner from './jobs-app/_spinner.vue';

const props = defineProps({
	api_url: {
		type: String,
		required: true,
	},
	logo_url_template: {
		type: String,
		required: true,
	},
});

const data = {
	work_environments: [`remote`],
	page: 1,
	limit: 6,
	search_mode: `hybrid`,
};

const { data: response, isFetching: loading } = useFetch(`${props.api_url}/api/listings/search`, {
	credentials: `same-origin`,
})
	.post(data)
	.json();

const items = computed(() => response.value?.items || []);
</script>
